import { Building2 } from "lucide-react";

const clients = [
  { name: "Hutchinson Builders", id: "hutchinson", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/jdvhcrdm_IMG_1485.jpeg" },
  { name: "Mosaic Property Group", id: "mosaic", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/0p420usu_IMG_1486.jpeg" },
  { name: "McNab", id: "mcnab", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/8ep5xx3e_IMG_1490.jpeg" },
  { name: "Usher Group", id: "usher", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/s5wdql3u_IMG_1488.jpeg" },
  { name: "Badge Construction", id: "badge", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/pjneqmcc_IMG_1491.jpeg" },
  { name: "MFP", id: "mfp", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/fm5irs9d_IMG_1492.jpeg" },
  { name: "Fineline Commercial", id: "fineline", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/ya1dzjn8_IMG_1496.jpeg" },
  { name: "Dankav", id: "dancav", logo: "https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/bvbc4b24_IMG_1497.jpeg" },
];

export const ClientsSection = () => {
  return (
    <section className="py-12 lg:py-16 bg-white border-b border-slate-100" data-testid="clients-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <span className="inline-block text-[#F59E0B] font-medium text-sm uppercase tracking-wider mb-3">
            Trusted Partners
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#0F172A] uppercase">
            Trusted by Industry Leaders
          </h2>
        </div>

        {/* Clients Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 items-center">
          {clients.map((client) => (
            <div
              key={client.id}
              className="group flex flex-col items-center justify-center p-4 rounded-lg hover:bg-slate-50 transition-colors"
              data-testid={`client-${client.id}`}
            >
              {client.logo ? (
                <img 
                  src={client.logo} 
                  alt={client.name}
                  className="h-16 w-auto object-contain mb-2"
                />
              ) : (
                <>
                  <div className="w-14 h-14 bg-[#0F172A] rounded-xl flex items-center justify-center mb-3 group-hover:bg-[#F59E0B] transition-colors">
                    <Building2 className="w-7 h-7 text-white" />
                  </div>
                  <p className="text-sm font-medium text-[#0F172A] text-center leading-tight">
                    {client.name}
                  </p>
                </>
              )}
            </div>
          ))}
        </div>

        {/* Trust Message */}
        <p className="text-center text-slate-500 mt-8 text-sm">
          Delivering quality caulking services to Queensland's leading construction companies
        </p>
      </div>
    </section>
  );
};
